<template>
    <div class="settings">
        <Header :app="app" :left="true" title="Passcodes">
            <template v-slot:left>
                <router-link to="/">
                    &laquo;
                </router-link>
            </template>
        </Header>

        <div class="content">
            <div class="field">
                <table class="table passcodes">
                    <thead>
                        <tr>
                            <th class="with-padding">Name</th>
                            <th class="with-padding">PIN</th>
                            <th class="with-padding">Permissions</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="staff in app.staff" :key="staff.id">
                            <td>
                                <input type="text" v-model="staff.name" placeholder="Name" v-on:blur="app.save(staff)">
                            </td>
                            <td>
                                <input type="tel" v-model="staff.pin" v-on:blur="app.save(staff)" class="align-center" min="0" max="9999" maxlength="4" pattern="\d{4}" placeholder="0000">
                            </td>
                            <td class="with-padding">
                                <ul class="permissions">
                                    <li v-for="location in app.locations" :key="location.id">
                                        <label>
                                            <input type="checkbox">
                                            {{location.name}}
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <input type="checkbox">
                                            Analytics
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <input type="checkbox">
                                            Passcodes
                                        </label>
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <a href="javascript:;" v-on:click="app.remove(app.staff, staff, 'staff member')" class="remove">&times;</a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <br>

                <a href="javascript:;" class="button" v-on:click="app.addStaff()">
                    + Add Staff
                </a>
            </div>
            <!-- <p>Check-in vs. Present</p> -->
        </div>
    </div>
</template>

<script>
import Header     from '@/components/header/component.vue';

export default {
    name: 'analytics',
    props: ['app'],
    components: {
        Header
    }
};
</script>
